export default{
  /* "key":"value" */
  "langauge-en" : "English",
  "langauge-ko" : "Korean",

  "main.description" : "If you have a brand mascot and are looking for fresh ways to drive<br></br> your users to web, then it is time to <b>Jump into the Conversation</b><br></br> with mojitok ADsticker.",

  "about.title" : "What is an ADsticker?",
  "about.description" : "<p>When a user types a particular word, context, or situation in a messenger,</p><p>ADsticker delivers your brand’s advertising content in the form of a sticker.</p><pit>※Sticker refer to emoticons used on mojitok.</pit>",
  "about.btn.contactUs": "Contact us",

  "feature.title" : "Features",
  "feature.guarantee.title" : "Guaranteed views",
  "feature.guarantee.description" : "Know how many views you will get on your ADsticker within your campaign period.",
  "feature.matching.title" : "Creator collaborations",
  "feature.matching.description" : "No need to worry about producing your own stickers. Simplify production by collaborating with one of our experienced creators.",
  "feature.channels.title" : "Diverse channels",
  "feature.channels.description" : "ADstickers are distributed to a variety of messengers through mojitok, reaching 300,000,000 users around the world.<pit>* mojitok is an intelligent sticker API/SDK that can be implemented in any messaging service.</pit>",

  "keyword.title" : "Keyword-based advertising",
  "keyword.description" : "<p>Keyword setting based on your brand’s</p><p> advertising goals.</p><p>Targets conversations related to </p><p>the keywords to give stickers </p><p>focused exposure.</p>",

  "targetBranding.btn" : "",

  "contact.title" : "Your AD isn’t in another castle, it’s right here!<br></br>Drop us a message to see your mascot <br></br>turn into an ADsticker. <br></br>",
  "contact.required" : "<t>*</t>Required field",
  "contact.form.radio.brand" : "Brand",
  "contact.form.radio.agency" : "Agency",

  "contact.form.companyName" : "Company name",
  "contact.form.companyName.required" : "Please enter your company name.",
  "contact.form.companyDescription" : "Brand or Agency description",
  "contact.form.name" : "Your name",
  "contact.form.name.required" : "Please enter your name.",
  "contact.form.email" : "Email address",
  "contact.form.email.required" : "Please provide a valid email address.",
  "contact.form.email.type" : "Invalid email address.",
  "contact.form.phoneNumber" : "Your phone number",
  "contact.form.message" :"Tell us more",
  "contact.form.message.required" : "Please enter your message here.",
  "contact.button" : "Send"
  
}